/** @module SiteAdmin/PreferenceViewType */
define([
	"dojo/_base/declare",
	"csi/def",
	"csi/heading/Expression",
	"csi/locale",
	"csi/model/customView",
	"csi/prefs",
	"csi/state/viewUtils"
], function (declare, def, Expression, locale, {isCustomViewContainerTypeKey}, csiPrefs, { VIEW_TYPE_GALLERY }) {

	return declare(Expression, {

		/**
		 * @override
		 * Return type of view
		 */
		_getValue: function (ctx, h) {
			const url = ctx.getNode().__Parent__;
			const key = csiPrefs.getContainerKey(url);
			const keyObj = def.decomposeViewKey(key);
			const defType = def.typeDefinition(keyObj.type);
			const viewId = keyObj.id;

			if (keyObj.isGallery) {
				return VIEW_TYPE_GALLERY;
			}

			if (isCustomViewContainerTypeKey(key)) {
				return locale.resource("DialogView");
			}

			return defType.getViewType(viewId);
		}
	});
});